export default {
  SettingOrderSourceStrategySourcing: {
    title: 'Drag to sort, the higher the priority, the higher it ranks.',
    freightCost: 'Low Shipping Cost',
    distance: 'Short Shipping Distance',
    warehouseNum: 'Fewer Delivery Warehouses'
  }
};
